<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="20"
      height="20"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">登录验证提示</div>

<div class="content" [ngClass]="{ active: 1 === activeIndex }">
  <div class="step">第一步</div>
  <div class="tip">
    <mat-icon style="color: rgb(244, 105, 105)">error</mat-icon>
    如果没有要求您填写验证码，请忽略此功能
  </div>
  <div class="detail">
    当您登录时遇到"此电视/设备不属于家庭" 消息时:点击"我在旅行"或"暂时观看"
    <img
      src="../../../../assets/images/get-link-step1.webp"
      alt="step"
      width="488"
      height="276"
    />
  </div>
</div>

<div class="content" [ngClass]="{ active: 2 === activeIndex }">
  <div class="step">第二步</div>
  <div class="detail">
    点击‘发送电子邮件’
    <img
      src="../../../../assets/images/get-link-step2.webp"
      alt="step"
      width="488"
      height="auto"
    />
  </div>
</div>

<div class="content" [ngClass]="{ active: 3 === activeIndex }">
  <div class="step">第三步</div>
  <div class="detail">
    点击网站上的车票，找到自己对应的Netflix 车票获取验证链接
    <img
      src="../../../../assets/images/get-link-step3.webp"
      alt="step"
      width="488"
      height="auto"
    />
  </div>
</div>

<div class="content" [ngClass]="{ active: 4 === activeIndex }">
  <div class="step">第四步</div>
  <div class="detail">
    成功获得链接后，点击‘打开链接’，即可 获得验证码
    <img
      src="../../../../assets/images/get-link-step4.webp"
      alt="step"
      width="488"
      height="auto"
    />
  </div>
</div>

<div class="content" [ngClass]="{ active: 5 === activeIndex }">
  <div class="step">第五步</div>
  <div class="detail">
    在奈飞中输入获得的验证码，完成验证 即可继续观看
    <img
      src="../../../../assets/images/get-link-step5.webp"
      alt="step"
      width="488"
      height="auto"
    />
  </div>
</div>

<div class="tabs">
  <div
    *ngFor="let data of [1, 2, 3, 4, 5]"
    class="tab"
    (click)="tab(data)"
    [ngClass]="{ active: data === activeIndex }"
  ></div>
</div>

<div class="button" [ngClass]="{ active: 1 === activeIndex }">
  <button (click)="next(1)">下一步</button>
  <button (click)="skip()">跳过教程</button>
</div>

<div
  *ngFor="let index of [2, 3, 4]"
  class="button"
  [ngClass]="{ active: index === activeIndex }"
>
  <button (click)="next(index)" style="width: 100%">下一步</button>
</div>

<div class="button" [ngClass]="{ active: 5 === activeIndex }">
  <button (click)="onOk()" style="width: 100%">获取链接</button>
</div>
